<h2 class="mb-5">{{ 'COMMON.CANDIDATES' | translate }}</h2>

<div class="card mb-4 border-0 shadow-sm">
  <div class="card-header bg-white pt-4 border-bottom-0">
    <h5>{{ 'CANDIDATES.SEARCHFILTERS' | translate }}</h5>
  </div>

  <div class="card-body">
    <form [formGroup]="candidateSearchForm" (ngSubmit)="onSubmit()">
      <div class="form-row">
        <div class="form-group col-md-2">
          <label for="candidateId">{{ 'COMMON.CANDIDATEID' | translate }}</label>
          <input type="text" class="form-control" id="candidateId" formControlName="candidateId" maxlength="15">
          <ct-control-messages [control]="candidateSearchForm.get('candidateId')"></ct-control-messages>
        </div>

        <div class="form-group col-md-2">
          <label for="email">{{ 'COMMON.EMAIL' | translate }}</label>
          <input type="email" class="form-control" id="email" formControlName="email">
          <ct-control-messages [control]="candidateSearchForm.get('email')"></ct-control-messages>
        </div>

        <div class="form-group col-md-2">
          <label for="idCard">{{ 'COMMON.DOCUMENT' | translate }}</label>
          <input type="text" class="form-control" id="idCard" formControlName="idCard">
          <ct-control-messages [control]="candidateSearchForm.get('idCard')"></ct-control-messages>
        </div>

        <div class="form-group col-md-2">
          <label for="name">{{ 'COMMON.NAME' | translate }}</label>
          <input type="text" class="form-control" id="name" formControlName="name">
          <ct-control-messages [control]="candidateSearchForm.get('name')"></ct-control-messages>
        </div>

        <div class="form-group col-md-2">
          <label for="surname">{{ 'COMMON.SURNAME' | translate }}</label>
          <input type="text" class="form-control" id="surname" formControlName="surname">
          <ct-control-messages [control]="candidateSearchForm.get('surname')"></ct-control-messages>
        </div>

        <div class="form-group col-md-2">
          <label>&nbsp;</label>
          <button type="submit" class="btn btn-primary form-control" [disabled]="candidateSearchForm.invalid">
            <i class="fa fa-search"></i> {{ 'COMMON.SEARCH' | translate }}
          </button>
        </div>
      </div>
    </form>

  </div>
</div>

<ct-datatable [items$]="candidates$" (reload)="searchCandidates($event.page)" class="datatable">
  <thead>
    <tr>
      <th colspan="1" id="results">{{ 'CANDIDATES.ALLRESULTS' | translate }} ({{ (candidates$ | async)?.total || 0 }})</th>
      <th colspan="5"></th>
      <th colspan="1" id="actions">
        <div ngbDropdown placement="bottom-right">
          <div ngbDropdownToggle> {{ 'CANDIDATES.ACTIONS' | translate }}</div>
          <div ngbDropdownMenu>
            <button ngbDropdownItem routerLink="/consultant/candidates/create">{{ 'CANDIDATES.ADDCANDIDATE' | translate }}</button>
            <button ngbDropdownItem routerLink="/consultant/candidates/upload">{{ 'CANDIDATES.ADDCANDIDATESFROMFILE' | translate }}</button>
          </div>
        </div>
      </th>
    </tr>
  </thead>
  <thead>
    <tr>
      <th>{{ 'COMMON.CANDIDATEID' | translate }}</th>
      <th>{{ 'CANDIDATES.NAMESURNAME' | translate }}</th>
      <th>{{ 'COMMON.EMAIL' | translate }}</th>
      <th>{{ 'COMMON.DOCUMENT' | translate }}</th>
      <th>{{ 'COMMON.RANDSTAD' | translate }}</th>
      <th>{{ 'COMMON.HISTORIC' | translate }}</th>
      <th>{{ 'CANDIDATES.ACTIONS' | translate }}</th>
    </tr>
  </thead>
  <tbody class="bg-white">
    <tr *ngFor="let candidate of (candidates$ | async)?.data">
      <td>{{ candidate.randstadCandidate }}</td>
      <td>{{ (candidate.name || '') + ' ' + (candidate.surname1 || '') + ' ' + (candidate.surname2 || '') | titlecase }}</td>
      <td>{{ candidate.email | lowercase }}</td>
      <td>{{ candidate.idCard }}</td>
      <td><img *ngIf="candidate.origin === 'web'" src="/assets/images/randstad-icon.png" alt="Randstad" class="randstad-icon"></td>
      <td>
        <i class="fa fa-list-alt" *ngIf="candidate.hasInvitation > 0" (click)="openHistory(candidate)" [ngbTooltip]="'TOOLTIP.HISTORIC' | translate"></i>
      </td>
      <td>
        <i class="fa fa-plus-circle" (click)="openInvite(candidate)" [ngbTooltip]="'TOOLTIP.NEWTEST' | translate"></i>
      </td>
    </tr>
    <tr *ngIf="!(candidates$ | async)?.data.length">
      <td colspan="8" class="text-center">{{ 'CANDIDATES.NORESULTS' | translate }}</td>
    </tr>
  </tbody>
</ct-datatable>

<ct-invite (inviteSent)="searchCandidatesFromHistoric()"></ct-invite>
